<template>
  <div class="widgets-list">
    <div
      v-for="(widget, index) in widgets"
      :key="index"
      :class="getClassWidget(widget)"
      class="widget"
    >
      <TheContent :elem="widget" />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/TheContent';
  import type { TContent } from '~/types/common';

  export default defineNuxtComponent({
    name: 'WidgetList',

    components: {
      TheContent,
    },

    props: {
      widgets: {
        type: Array as PropType<TContent[]>,
        required: true,
      },
    },

    methods: {
      getClassWidget(widget: TContent): string | null {
        return `widget--${widget.type}`;
      },
    },
  });
</script>
